import { useCallback } from "react";
import { useSheetSignature as useSheetSignatureBase } from "common-fe";
import { useScoreApi, unwrap } from "../api/scoreApi";

// scribe wrapper around common-fe's useSheetSignature (card #735): wires
// score-api's getScoreSheetSignature as the fetcher (mirrors
// scoreadmin-fe/src/hooks/useSheetSignature.js). Pass `enabled` (the sheet's
// signed state, e.g. `Boolean(isCompleted)`) so the fetch only happens once a
// signature actually exists to show.
export function useSheetSignature(sheetId, opts) {
  const scoreApi = useScoreApi();
  const fetchSignature = useCallback(
    async (id) => unwrap(await scoreApi.scoreSheets.getScoreSheetSignature(id)),
    [scoreApi],
  );
  return useSheetSignatureBase(sheetId, fetchSignature, opts);
}

export default useSheetSignature;
